import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  stepBusinessInformation: {
    id: "onboarding: step business information",
    defaultMessage: "Business information",
  },
  stepContactDetails: {
    id: "onboarding: step contact details",
    defaultMessage: "Contact details",
  },
  stepBusinessCountry: {
    id: "onboarding: step business country",
    defaultMessage: "Business country",
  },
  stepMonthlyRevenue: {
    id: "onboarding: step monthly revenue",
    defaultMessage: "Monthly revenue",
  },
  stepFundingDetails: {
    id: "onboarding: step funding details",
    defaultMessage: "Funding details",
  },
  stepBusinessDetails: {
    id: "onboarding: step business details",
    defaultMessage: "Business details",
  },
  stepConnectionsAndData: {
    id: "onboarding: step connections and data",
    defaultMessage: "Connections and data",
  },
  stepApplicationReview: {
    id: "onboarding: step application review",
    defaultMessage: "Application review",
  },
});
